import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'next/navigation';
import {
  PhonicsClassStatus,
  PhonicsLessonGroup,
  PhonicsLesson,
} from '@/api/types';
import { ManageLessonPod } from './ManageLessonPod';
import { ManageYearWeekLessonAccordion } from './ManageYearWeekLessonAccordion';

interface ManageLessonsListProps {
  lessonGroups: Array<PhonicsLessonGroup>;
  phonicsClass: PhonicsClassStatus;
  onViewDetail: (lesson: PhonicsLesson) => void;
  onViewResults: (lesson: PhonicsLesson) => void;
  onLaunchLesson: (lesson: PhonicsLesson) => void;
  onAddNotes: (lesson: PhonicsLesson) => void;
}

export const ManageLessonsList = ({
  lessonGroups,
  phonicsClass,
  onViewDetail,
  onViewResults,
  onLaunchLesson,
  onAddNotes,
}: ManageLessonsListProps) => {
  const searchParams = useSearchParams();

  const [openYearGroup, setOpenYearGroup] = useState<
    PhonicsLessonGroup | undefined
  >();

  const [openWeekGroup, setOpenWeekGroup] = useState<
    PhonicsLessonGroup | undefined
  >();

  const openWeekGroupId = searchParams.get('weekGroupId');

  useEffect(() => {
    if (!phonicsClass) {
      return;
    }

    setOpenYearGroup(
      lessonGroups.find((yearGroup) =>
        yearGroup.children?.find((weekGroup) => {
          if (openWeekGroupId && weekGroup.id === openWeekGroupId) {
            setOpenWeekGroup(weekGroup);

            return true;
          }

          const isOpen = weekGroup.lessons?.find(
            (lesson) => lesson.id === phonicsClass.currentLessonId,
          );

          if (isOpen) {
            setOpenWeekGroup(weekGroup);
          }

          return isOpen;
        }),
      ),
    );
  }, [phonicsClass, lessonGroups]);

  return (
    <ManageYearWeekLessonAccordion
      lessonGroups={lessonGroups}
      openYearGroup={openYearGroup}
      setOpenYearGroup={setOpenYearGroup}
      openWeekGroup={openWeekGroup}
      setOpenWeekGroup={setOpenWeekGroup}
      onRenderLesson={(lesson) => (
        <div>
          <h3 className="font-bold text-pt-primary text-center">
            Lesson {lesson.number}
          </h3>

          <ManageLessonPod
            lesson={lesson}
            currentLessonId={phonicsClass?.currentLessonId || undefined}
            phonicsClass={phonicsClass}
            inverted
            onViewDetail={() => onViewDetail(lesson)}
            onViewResults={() => onViewResults(lesson)}
            onLaunchLesson={() => onLaunchLesson(lesson)}
            onAddNotes={() => onAddNotes(lesson)}
          />
        </div>
      )}
    />
  );
};
